import { RecommendedCarrier } from "./carrier-recommendation-model";

export const ALL_CARRIER_RECOMMENDATION_RESPONSE = "ALL_CARRIER_RECOMMENDATION_RESPONSE"

export type LineOfBusinessCarrierInfo = {
  lineOfBusiness: string;
  carrierInfos: RecommendedCarrier[];
};

export type AllCarrierRecommendationResponse = {
    type: typeof ALL_CARRIER_RECOMMENDATION_RESPONSE;
    data: LineOfBusinessCarrierInfo[];
};